import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { useToastContext } from "../../Lib/Contexts/toastContext";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDeleteMyPanel } from "../../hooks/useGetDataQuery";
import { Tooltip } from "primereact/tooltip";
import { InputText } from "primereact/inputtext";
import { useDrag, useDrop } from "react-dnd";

const OldPanelsSection = ({ myPanels, setMyPanel, handleSelectExerciseOnEdit, editModeEnabledOnWhichPanel, setEditModeEnabledOnWhichPanel, updatePanel, activeIndex, setActiveIndex, t }: any) => {
    const { showToast }: any = useToastContext();
    const [deletedPanel, setDeletedPanel] = useState<any>()

    const {
        mutate: deleteMyPanelMutation,
        isSuccess: isSuccessDeleteMyPanel,
        isPending: isPendingDeleteMyPanel,
    } = useDeleteMyPanel();

    useEffect(() => {
        if (isSuccessDeleteMyPanel) {
            showToast({
                severity: "success",
                summary: "Success",
                detail: "Panel deleted successfully!",
            });
            setMyPanel((prevPanels: any) => prevPanels.filter((panel: any) => panel.id !== deletedPanel?.id));
        }
    }, [isSuccessDeleteMyPanel]);

    const deletePanel = (currentPanel: any, e: any) => {
        setDeletedPanel(currentPanel)
        e.stopPropagation();
        deleteMyPanelMutation({id:currentPanel.id})
    }

    const handleEditModeButton = (e:any, panel:any) => {
        e.stopPropagation();
        if (editModeEnabledOnWhichPanel?.id === panel.id) {
            setEditModeEnabledOnWhichPanel(null);
            setActiveIndex(null);
        } else {
            setEditModeEnabledOnWhichPanel(panel);
            setActiveIndex(myPanels.findIndex((p: any) => p.id === panel.id));
        }
    }

    const headerContent = (panel: any) => {
        return (
            <div
                className="flex align-items-center justify-content-between m-2 pr-2"
                style={{
                    height: "2rem"
                }}
            >
                <div className="flex gap-4 align-items-center">
                    <img src="/panelIcon.svg" style={{ backgroundColor: "#EBEDF2", borderRadius: "10px" }} />
                    {(editModeEnabledOnWhichPanel?.id === panel.id)? (
                        <div className='w-25rem'>
                            <InputText id="panelName" className='w-full' style={{ borderRadius: "10px" }} value={editModeEnabledOnWhichPanel?.name}
                                onChange={(e:any) => { setEditModeEnabledOnWhichPanel({...editModeEnabledOnWhichPanel, name: e.target.value}) }} placeholder={t("enterPanelName")} onKeyDown={(e:any) => e.stopPropagation()} />
                        </div>
                    ) : (
                        <p>{panel.name}</p>
                    )}
                </div>
                <div className="flex gap-2">
                    <Button
                        icon={<img src={"/editIconBlue.svg"} />}
                        onClick={(e:any) => handleEditModeButton(e, panel)}
                        style={{
                            border: "none",
                            backgroundColor: (editModeEnabledOnWhichPanel?.id === panel.id) ? "#b7c7f6ff" : "#EBEDF2",
                            borderRadius: "10px",
                            width: "2rem",
                            height: "2rem",
                            transition: "background-color 0.5s ease"
                        }} />
                    <Tooltip target=".pi-check-circle" />
                    <Button
                        icon={(editModeEnabledOnWhichPanel?.id === panel.id) ? <i data-pr-tooltip={t("confirmUpdate")} data-pr-position="bottom" className="pi pi-check-circle" style={{color: "#23CF95"}}></i> : <img src="/redTrashIcon.svg" width={20} height={20} />}
                        onClick={(e) => (editModeEnabledOnWhichPanel?.id === panel.id) ? updatePanel(e) : deletePanel(panel, e)}
                        loading={isPendingDeleteMyPanel}
                        style={{
                            border: "none",
                            backgroundColor: (editModeEnabledOnWhichPanel?.id === panel.id) ? "#E1FAF1" : "#FCEEF0",
                            borderRadius: "10px",
                            width: "2rem",
                            height: "2rem"
                        }} />
                </div>
            </div>
        )
    }

    const moveCard = useCallback(
        (dragIndex: number, hoverIndex: number) => {
            setEditModeEnabledOnWhichPanel((prev: any) => {
            const newExerciseProcedure = [...prev.exerciseProcedure];
            const [movedItem] = newExerciseProcedure.splice(dragIndex, 1);
            newExerciseProcedure.splice(hoverIndex, 0, movedItem);
            return {
                ...prev,
                exerciseProcedure: newExerciseProcedure,
            };
            });
        },
        [setEditModeEnabledOnWhichPanel]
    );


    const DragItem = ({ exercise, panelId, index, moveCard }: any) => {
        const ref = useRef<HTMLDivElement>(null);

        const [{ handlerId }, drop] = useDrop({
            accept: "exercise",
            collect(monitor) {
                return {
                    handlerId: monitor.getHandlerId(),
                };
            },
            hover(item: any, monitor: any) {
                if (!ref.current) {
                    return;
                }
                const dragIndex = item.index;
                const hoverIndex = index;

                if (dragIndex === hoverIndex) {
                    return;
                }

                const hoverBoundingRect = ref.current.getBoundingClientRect();
                const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
                const clientOffset = monitor.getClientOffset();
                
                if (!clientOffset) {
                    return;
                }
                
                const hoverClientY = clientOffset.y - hoverBoundingRect.top;

                if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                    return;
                }

                if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                    return;
                }

                moveCard(dragIndex, hoverIndex);

                item.index = hoverIndex;
            },
        });

        const [{ isDragging }, drag] = useDrag({
            type: "exercise",
            item: () => {
                return { id: exercise.id, index };
            },
            collect: (monitor: any) => ({
                isDragging: monitor.isDragging(),
            }),
        });

        const opacity = isDragging ? 0.4 : 1;
        drag(drop(ref));

        return (
            <div key={index} className="flex flex-column" style={{ opacity, backgroundColor: isDragging ? "#f0f0f0" : "transparent", cursor: `${editModeEnabledOnWhichPanel?.id === panelId ? "move" : "default"}` }} ref={editModeEnabledOnWhichPanel?.id === panelId ? ref : null}>
                <div
                    className="flex align-items-center justify-content-between my-1 mx-2 p-2 pr-5" style={{ borderRadius: "10px", }}>
                    <div className="flex gap-4 align-items-center">
                        <img src={exercise.exerciseImg} width={50} height={50} style={{ backgroundColor: "#FFFFFF", borderRadius: "10px" }} />
                        <p className="font-bold text-md" style={{ color: "#2D3967" }}>{exercise.exerciseName}</p>
                    </div>
                    {(editModeEnabledOnWhichPanel?.id === panelId) && (
                        <div className="flex gap-2">
                            <Button
                                icon={<img src="/editIconBlue.svg" />}
                                onClick={() => handleSelectExerciseOnEdit({ ...(editModeEnabledOnWhichPanel?.exerciseProcedure?.find((ex: any) => ex.procedureId === exercise.procedureId)), panelId: panelId })}
                                style={{
                                    border: "none",
                                    backgroundColor: "#EBEDF2",
                                    borderRadius: "10px",
                                    width: "2rem",
                                    height: "2rem"
                                }}
                            />
                            <Button
                                icon={<img src="/redTrashIcon.svg" width={20} height={20} />}
                                onClick={() => {  }}
                                style={{
                                    border: "none",
                                    backgroundColor: "#FCEEF0",
                                    borderRadius: "10px",
                                    width: "2rem",
                                    height: "2rem"
                                }} 
                            />
                            <img src="/dragIcon.svg" style={{ cursor: "grab" }} />
                        </div>
                    )}
                </div>
            </div>
        )
    };

    const exerciseDivs = (panelExerciseList: any) => {
        const panelId = panelExerciseList.id;
        return panelExerciseList.exerciseProcedure.map((exercise: any,index:any) => (
            <DragItem 
                exercise={exercise}
                panelId={panelId}
                index={index}
                moveCard={moveCard}
                key={exercise.procedureId}
            />
        ));
    }

    const createDynamicTabs = () => {
        return myPanels.map((panel: any, index:number) => {
            return (
                <AccordionTab key={panel.id} header={() => headerContent(panel)}>
                    {(activeIndex === index) ? exerciseDivs(editModeEnabledOnWhichPanel) : exerciseDivs(panel)}
                </AccordionTab>
            );
        });
    };

    return (
        <div className="w-full libraryAccordion" >
            <Accordion activeIndex={activeIndex}>
                {createDynamicTabs()}
            </Accordion>
        </div>
    )
}

export default OldPanelsSection;